export default {"src":"/_next/static/media/Empty State_No Data.d92b691a.svg","height":165,"width":171,"blurWidth":0,"blurHeight":0};